<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="Images" src="images/img6.jpg"/></p>
<p class="caption">Maintaining traditions. John Karras (right) and Carter LeBeau have tried to share a slice of watermelon on every RAGBRAI. <i>Kaye and Carter LeBeau</i>.</p>
<p class="pg"> </p>
<p class="h1" id="f1">FOREWORD</p>
<p class="center"><i>What The Great Six-Day Bike Trip Across Iowa</i> [as the first RAGBRAI was called] <i>is really all about is youth—a state of mind, not an age</i>.</p>
<p class="noindent1">John Karras wrote these words in 1973 at the age of forty-two. Forty-one years later, when he wrote this foreword, he was still maintaining his youthful spirit and participating in RAGBRAI.</p>
<p class="image1"><img alt="Images" src="images/imgcommon.jpg"/></p>
<p class="noindent">You are holding a comprehensive examination of an annual event of considerable magnitude that Donald Kaul and I started in 1973 in complete innocence of any expectation of what it would become. It’s called (I named it, actually) the <i>Register</i>’s Annual Great Bicycle Ride Across Iowa, RAGBRAI, followed by a Roman numeral designating its order. We’re at RAGBRAI XLI this year, and still counting.</p>
<p class="indent">The event has evolved, and continues to evolve, since its humble beginning. The truth is that what Kaul and I envisioned was a weeklong ride by just the two of us with the <i>Register</i> picking up our expenses. Then the managing editor of the day, Ed Heins, suggested that I “invite the readers to come along,” as he put it. I wrote about eight inches of type outlining our intentions, starting point and a few sketchy details of what to expect. (Truth is, I hadn’t the foggiest notion of what to expect.)</p>
<p class="indent">Kaul and I didn’t expect anyone to show up and thus were astonished to see 250 or so people in the parking lot at the Sioux City motel we were starting from. So much for our pleasant little solitary romp through the countryside.</p>
<p class="indent">From that beginning, participation soared year after year. Astonishing as it is, for all these years it has worked. Hardly any of our worst fears have materialized.</p>
<p class="indent">In this book, Greg Borzo has attempted (and in my view succeeded) to capture both the details and the spirit of this grand annual event—an Iowa State Fair on wheels, if there ever was one.</p>
<p class="right1">J<span class="small">OHN</span> K<span class="small">ARRAS</span></p>
<p class="right"><i>March 2013</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// foreword.vue?4cb75fc6